import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2124Status: 'idle',
    startProcess2124Error: undefined as any,
    loadUserParamsProcess2124Status: 'idle',
    loadUserParamsProcess2124Error: undefined as any,

    process2124List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2124 = createAsyncThunk('process2124Slice/startProcess2124', async ({ process2124 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2124/`,
        prepareData(process2124),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2124Status } = getState().process2124Slice
        return startProcess2124Status !== 'pending'
    }
})

export const loadUserParamsProcess2124 = createAsyncThunk('process2124Slice/loadUserParamsProcess2124', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2124/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2124Status } = getState().process2124Slice
        return loadUserParamsProcess2124Status !== 'pending'
    }
})

const Process2124Slice = createSlice({
    name: 'process2124Slice',
    initialState,
    reducers: {
        resetstartProcess2124: (state) => {
            state.job = undefined
            state.startProcess2124Error = undefined
        },
        resetstartProcess2124Error: (state) => {
            state.startProcess2124Error = undefined
        },
        resetloadUserParamsProcess2124: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2124Error = undefined
        },
        resetloadUserParamsProcess2124Error: (state) => {
            state.loadUserParamsProcess2124Error = undefined
        },
        removeFromProcess2124ListById: (state, action) => {
            state.process2124List = state.process2124List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2124ListByIds: (state, action) => {
            state.process2124List = state.process2124List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2124List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2124Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2124List = []
            state.startProcess2124Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2124.pending, (state) => {
            state.startProcess2124Status = 'pending'
            state.startProcess2124Error = undefined
        })
        builder.addCase(startProcess2124.fulfilled, (state, action) => {
            state.startProcess2124Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2124.rejected, (state, action) => {
            state.startProcess2124Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2124Error = action.error.message
            } else {
                state.startProcess2124Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2124.pending, (state) => {
            state.loadUserParamsProcess2124Status = 'pending'
            state.loadUserParamsProcess2124Error = undefined
        })
        builder.addCase(loadUserParamsProcess2124.fulfilled, (state, action) => {
            state.loadUserParamsProcess2124Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2124.rejected, (state, action) => {
            state.loadUserParamsProcess2124Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2124Error = action.error.message
            } else {
                state.loadUserParamsProcess2124Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2124,
    resetstartProcess2124Error,
    resetloadUserParamsProcess2124,
    resetloadUserParamsProcess2124Error,
    removeFromProcess2124ListById,
    removeFromProcess2124ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2124Slice.actions
export default Process2124Slice.reducer
